import * as React             from 'react';
import { StatelessComponent } from 'react';
import icons                  from '../icons';
import Expire                 from './Expire';

export type CloseAlertType = (type: AlertTypes) => void;
export enum AlertTypes {
    PRIMARY = 'primary',
    DANGER = 'danger',
    SUCCESS = 'success',
    WARNING = 'warning'
}

interface Props {
    message: string,
    type?: string,
    delay?: number,
    condition?: boolean,
    showCloseButton?: boolean
}

const renderCloseButton = (closeBtnVisible: boolean, handleCloseButton: () => void) => {
    if (closeBtnVisible) {
        return (
            <span className="Alert__close" onClick={handleCloseButton}>
                {icons.close('#000000')}
            </span>
        );
    }
};

export const Alert: StatelessComponent<Props> = ({ condition, message, type, delay, showCloseButton }) => {

    const [isVisible, setVisibility] = React.useState(true);
    const handleHideAlert = () => setVisibility(false);
    if (!isVisible) {
        return null;
    }

    return condition && message ? (
        <div className="alert">
            <Expire delay={delay}>
                <div className={'alert__container ' + type}>
                    <div className={'alert__message ' + type + '_message'}>
                        {icons.alertCircle} <div className={'alert__text_' + type}>{ message }</div>
                    </div>
                    {renderCloseButton(showCloseButton, handleHideAlert)}
                </div>
            </Expire>
        </div>
    ) :
    null;
};

Alert.defaultProps = {
    condition: true,
    type: 'error',
};

export default Alert;



// WEBPACK FOOTER //
// ./src/components/Alert.tsx